import { c as _c } from "react/compiler-runtime";
import { LogoWrapper } from '@libs/contentful';
export default function HeaderMini() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{"\n                    .banner-container {\n                        height: 64px;\n                        border-bottom: 1px solid var(--sparky-color-neutral-200);\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                    }\n\n                    @media (min-width: 560px) {\n                        .banner-container {\n                            height: 80px;\n                        }\n                    }\n                "}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>{t0}<div role="banner" className="banner-container"><LogoWrapper /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}